import { Box, Text } from '@medly-components/core';

import { ArrowBackIcon } from '@medly-components/icons';
import { default as HeaderLayout } from 'components/layout/Header';
import { BACK, LOGOUT } from 'constants/onboarding';
import { useTheme } from 'styled-components';
import { ReactComponent as LogoutIcon } from '../../../assets/svg/logout.svg';
import { useLogoutFlow } from '../../../hooks/useLogout/useLogoutFlow';
import { FullScreenLoader } from '../FullscreenLoader/FullscreenLoader';
import { Logo } from '../Logo/Logo';
import { Header, LeftButton, ProgressBar, RightButton } from './OnboardingHeader.styled';
import { OnboardingHeaderProps } from './types';

export const OnboardingHeader = ({ showBackButton, onGoBack = () => {}, showLogoutButton, progress }: OnboardingHeaderProps) => {
    const { logout, loading } = useLogoutFlow();
    const theme = useTheme();

    return (
        <>
            <Header hideShadow={!!progress}>
                <FullScreenLoader loading={loading} />
                {showBackButton ? (
                    <HeaderLayout.LeftSide>
                        <LeftButton onClick={onGoBack}>
                            <ArrowBackIcon iconColor={`${theme.colors.darkBlue}`} />
                            <Text>{BACK}</Text>
                        </LeftButton>
                    </HeaderLayout.LeftSide>
                ) : null}
                <Box width="fit-content" style={{ position: 'absolute', left: '0', right: '0', margin: '0 auto' }}>
                    <Logo blackLogo={true} />
                </Box>
                {showLogoutButton ? (
                    <HeaderLayout.RightSide>
                        <RightButton onClick={() => logout(false)}>
                            <LogoutIcon />
                            <Text>{LOGOUT}</Text>
                        </RightButton>
                    </HeaderLayout.RightSide>
                ) : null}
            </Header>
            {progress && <ProgressBar progress={progress} />}
        </>
    );
};
